import icons from "../../../icons/timeline/nftClass";
import TimelineItemIcon from "../../../timeline/itemIcon";

export default function NftClassTimelineItemIcon({ name }) {
  return <TimelineItemIcon icons={icons} name={name} />;
}
